import { useEffect, useRef } from "react";

export function getDefaultSiteTitle() {
  if (typeof document === "undefined") {
    return "";
  }
  return document.indexTitle || document.title || "";
}

export function useTitle(title, { restore = false, fallback } = {}) {
  const prevTitleRef = useRef(getDefaultSiteTitle());

  useEffect(() => {
    const nextTitle = title ?? fallback ?? getDefaultSiteTitle();
    if (!nextTitle) {
      return;
    }
    if (restore) {
      prevTitleRef.current = document.title;
    }
    document.title = nextTitle;

    return () => {
      if (restore) {
        document.title = prevTitleRef.current || getDefaultSiteTitle();
      }
    };
  }, [title, restore, fallback]);
}

